import styled from 'styled-components';

export const StripeCardElementContainer = styled.div`
  background: #ffffff;
  width: 100%;
`;

export const StripeCardElementRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  margin-bottom: 16px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  color: #5b5b5b;

  .info-icon {
    flex-shrink: 0;
    font-size: 18px;
    color: #26b183;
  }

  ion-icon {
    flex-shrink: 0;
    font-size: 18px;
  }

  &:last-child {
    margin-bottom: 0px;
  }

  .tooltip {
    flex-shrink: 0;
    font-size: 13px;

    ion-icon {
      width: 13px;
      height: 13px;
    }
  }
`;

export const StripeCardElementHeading = styled.h4`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;

  margin-bottom: 16px;

  color: #1d201f;
`;

export const StripeCardElementForm = styled.form`
  margin-bottom: 24px;
`;
